"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExampleComponent = exports.fdsChartsI18nSetup = void 0;
const ExampleComponent_1 = require("./components/ExampleComponent/ExampleComponent");
Object.defineProperty(exports, "ExampleComponent", { enumerable: true, get: function () { return ExampleComponent_1.ExampleComponent; } });
__exportStar(require("./components/LineChart"), exports);
__exportStar(require("./components/TreeMapChart/TreeMap"), exports);
var setup_1 = require("./i18n/setup");
Object.defineProperty(exports, "fdsChartsI18nSetup", { enumerable: true, get: function () { return setup_1.fdsChartsI18nSetup; } });
exports.default = ExampleComponent_1.ExampleComponent;
